import React from 'react'
import { useNavigate } from 'react-router-dom'
import styled from '@emotion/styled'
import {
  openModal,
  resetOrder,
  resetQuote,
  selectOrder,
  useAppDispatch,
  useAppSelector,
} from '@open-tender/cloud'
import { ArrowRight, UserCircle } from '../../icons'
import { ButtonLarge } from '../..'

const GuestButtonsView = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-direction: row-reverse;
  padding: 0 ${(props) => props.theme.layout.padding};
  @media (max-width: ${(props) => props.theme.breakpoints.mobile}) {
    position: fixed;
    z-index: 10;
    bottom: 0;
    left: 0;
    right: 0;
    flex-direction: column;
    align-items: center;
    padding: ${(props) => props.theme.layout.paddingMobile};
    background-color: ${(props) => props.theme.bgColors.primary};
  }

  button {
    max-width: calc(50% - 1rem);
    min-width: ${(props) =>
      props.theme.welcome.desktop.showIcons ? '25rem' : '0'};
    padding-left: ${(props) => props.theme.welcome.desktop.buttonPaddingLeft};
    padding-right: ${(props) => props.theme.welcome.desktop.buttonPaddingRight};
    @media (max-width: ${(props) => props.theme.breakpoints.mobile}) {
      width: 100%;
      min-width: 100%;
      max-width: 100%;
      margin: 0;
      padding-left: ${(props) => props.theme.welcome.mobile.buttonPaddingLeft};
      padding-right: ${(props) =>
        props.theme.welcome.mobile.buttonPaddingRight};
    }
  }

  button + button {
    margin: 0 2rem 0 0;
    @media (max-width: ${(props) => props.theme.breakpoints.mobile}) {
      margin: ${(props) => props.theme.layout.paddingMobile} 0 0;
  }
`

const GuestButtons = React.forwardRef(
  (props, ref: React.LegacyRef<HTMLDivElement> | undefined) => {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const currentOrder = useAppSelector(selectOrder)
    const { revenueCenter, serviceType, cart } = currentOrder
    const isCurrentOrder =
      revenueCenter && serviceType && (cart?.length ?? 0) > 0

    const continueCurrent = () => {
      navigate(revenueCenter ? `/menu/${revenueCenter.slug}` : '/order-type')
    }

    const startNewOrder = () => {
      dispatch(resetOrder())
      dispatch(resetQuote())
      navigate(`/order-type`)
    }

    const login = () => {
      dispatch(openModal({ type: 'login' }))
    }

    return (
      <GuestButtonsView ref={ref}>
        <ButtonLarge
          onClick={login}
          text="Sign in or sign up"
          color="secondary"
        >
          <UserCircle size={22} />
        </ButtonLarge>
        <ButtonLarge
          onClick={isCurrentOrder ? continueCurrent : startNewOrder}
          text={isCurrentOrder ? 'Continue Order' : 'Order Now'}
          color="primary"
        >
          <ArrowRight size={22} strokeWidth={2} />
        </ButtonLarge>
      </GuestButtonsView>
    )
  }
)

export default GuestButtons
